/**
 * Creates an array of key/value pairs for a form. Output matches an array-converted [FormData.entries()](https://developer.mozilla.org/en-US/docs/Web/API/FormData/entries) iterable.
 * @param {HTMLFormControlsCollection} $controls
 */
export default function formEntries($controls) {
  /** @type {[[string, string]]} */
  const results = [];

  /** @type {[[string, string]]} */
  const hiddens = [];

  [...$controls].forEach(($el) => {
    const { type } = $el;

    if ($el.disabled || !$el.name || type === 'file' || type === 'reset' || type === 'submit' || type === 'button') {
      return;
    }

    if (type === 'hidden') {
      hiddens.push([$el.name, $el.value]);
      return;
    }

    if (type === 'select-multiple') {
      results.push(...[...$el.selectedOptions].map(($option) => [$el.name, $option.value]));
      return;
    }

    if ((type !== 'checkbox' && type !== 'radio') || $el.checked) {
      results.push([$el.name, $el.value]);
    }
  });

  return [
    ...results,
    ...hiddens.filter(([hiddenName]) => !results.find(([visible, visibleValue]) => visible === hiddenName && !!visibleValue)),
  ];
}
